import SkeletonLoading from "./SkeletonLoading";

function TemplateDetailsCard({ templateModelDesc, loading }) {
  return (
    <div className="bg-white shadow-md rounded-lg w-full mt-3 md:mt-5 py-4 px-6 cursor-default">
      <p className="text-2xl font-semibold mb-4">Template Details</p>
      {loading ? (
        <SkeletonLoading max_width="max-w-full" />
      ) : (
        <div className="grid gap-y-4">
          <div>
            <p className="text-gray-500">Model #</p>
            <p className="font-medium text-gray-600 break-words">
              {templateModelDesc?.name || "-"}
            </p>
          </div>
          <div>
            <p className="text-gray-500">Model Description</p>
            <p className="font-medium text-gray-600 break-words">
              {templateModelDesc?.model_description || "-"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default TemplateDetailsCard;
